import { StateKey } from 'common/utils/flipState'
import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import HttpStatus from 'common/utils/httpStatus'
import logger from 'common/logger'
import { MY_PAY_DEFAULT_VALUE } from 'common/constants/naverPay'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

const initialState: string = MY_PAY_DEFAULT_VALUE

const FETCH_MY_ORDER_DELIVERY_COUNTS = 'my/FETCH_MY_ORDER_DELIVERY_COUNTS'

export const fetchMyOrderDeliveryCounts = (curState: StateKey, headers?: any) => async dispatch => {
  try {
    const response = await axios.get('/v1/pay/order-delivery-counts', {
      ...getHeaders(headers),
      data: {
        [isErrorRejected]: true,
      },
    })
    dispatch({
      curState,
      type: FETCH_MY_ORDER_DELIVERY_COUNTS,
      orderDeliveryCounts: response && response.data,
    })
  } catch (err) {
    err.response.status !== HttpStatus.UNAUTHORIZED && logger.error(err)
    dispatch({
      curState,
      type: FETCH_MY_ORDER_DELIVERY_COUNTS,
      orderDeliveryCounts: initialState,
    })
  }
}

const myOrderDeliveryCountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MY_ORDER_DELIVERY_COUNTS:
      return action.orderDeliveryCounts
    default:
      return state
  }
}

export default myOrderDeliveryCountsReducer
